module["exports"] = [  
  "##",
  "#"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/id_ID/address/building_number.js
 ** module id = 640
 ** module chunks = 0
 **/